import styled from "@emotion/styled"
import theme from "css/theme/light"
import { Link } from "react-router-dom"

export const StyledTableLink = styled(Link)({
  color: theme.palette.secondary.main,
})
